import {BombeoService} from "saneamiento/service";
import {SearchAutocomplete} from "base/component/search";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const BombeoFormSearch = ({
    handleSelect = null,
    name = null,
    rules = {},
    disabled = false,
}) => {
    const optionComponent = option => {
        return (
            <Stack>
                <Typography>{option.nome}</Typography>
                <Typography variant="caption" sx={{ml: 1}}>
                    {option.codigo}
                </Typography>
            </Stack>
        );
    };

    return (
        <SearchAutocomplete
            name={name}
            label="Bombeo"
            optionLabelAttribute="nome"
            optionLabelSecondAttribute="codigo"
            optionComponent={optionComponent}
            search={BombeoService.getBySearchText}
            handleSelect={handleSelect}
            rules={rules}
            disabled={disabled}
        />
    );
};

export default BombeoFormSearch;
